export const DEFAULT_COST_TARGET = 28;

export interface CostTargets {
  food: number;
  drinks: number;
  overall: number;
}

export const DEFAULT_COST_TARGETS: CostTargets = {
  food: DEFAULT_COST_TARGET,
  drinks: DEFAULT_COST_TARGET,
  overall: DEFAULT_COST_TARGET,
};

export function resolveCostTargets(raw?: Partial<CostTargets> | null): CostTargets {
  const pick = (n: unknown) =>
    typeof n === 'number' && Number.isFinite(n) && n > 0 ? n : DEFAULT_COST_TARGET;
  return {
    food: pick(raw?.food),
    drinks: pick(raw?.drinks),
    overall: pick(raw?.overall),
  };
}

// FOOD → food target; DRINKS → drinks target; everything else (incl. undefined,
// TAKE_AWAY, CATERING) → overall target.
export function getCostTargetForDishType(
  type: string | undefined | null,
  targets: CostTargets,
): number {
  if (type === 'FOOD') return targets.food;
  if (type === 'DRINKS') return targets.drinks;
  return targets.overall;
}

export function getCostTargetForTab(
  // 'addons' falls through to the overall target — the Add-ons tab shows CHOICE
  // analyses which carry no price, so the cost-target check is informational only.
  tab: 'all' | 'food' | 'drinks' | 'addons',
  targets: CostTargets,
): number {
  if (tab === 'food') return targets.food;
  if (tab === 'drinks') return targets.drinks;
  return targets.overall;
}

// Preserves the legacy 1-point buffer: with target 28%, bad starts at 29%.
export function isCostBad(costPercentage: number, target: number): boolean {
  return costPercentage >= target + 1;
}
